module.exports = __webpack_public_path__ + "Flag-364.232aac4a074dde8811982a1287b02095.svg";